<template>
  <v-container class="pa-0">
    <v-toolbar flat>
      <v-toolbar-title>
        Payments
      </v-toolbar-title>
      <v-spacer />

    </v-toolbar>

    <base-stripe-table
      ref="paymentsTable"
      :headers="headers"
      :fetch-action="'listPayments'"
      :fetch-query="{ customer: $route.params.id }"
      :items-getter="'getPayments'"
      :pagination-getter="'getPaymentPagination'"
      class="customer-payments"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr
            v-for="item in items"
            :key="item.id"
          >
            <td v-money="{ amount: item.amount, currency: item.currency}" />
            <td>
              <payment-status-chip
                :payment="item"
              />
            </td>
            <td>{{ item.description }}</td>
            <td v-date="item.created" />
            <td>
              <v-menu
                v-if="canRefund(item)"
                left
              >
                <template v-slot:activator="{ on}">
                  <v-btn
                    icon
                    v-on="on"
                  >
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>

                <v-list dense>
                  <payment-refund-dialog
                    :id="item.id"
                    :customer="$route.params.id"
                    @action="reloadTable()"
                  >
                    <template v-slot:activator="{ on }">
                      <v-list-item
                        v-on="on"
                        @click.stop=""
                      >
                        <v-list-item-content>
                          <v-list-item-title>
                            <v-icon>replay</v-icon>
                            Refund
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </payment-refund-dialog>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </tbody>
      </template>
    </base-stripe-table>
  </v-container>
</template>
<style>
  .customer-payments td {
    padding: 0 10px;
  }
</style>
<script>
import { get } from 'lodash'
import BaseStripeTable from '@/components/Common/BaseStripeTable'
import PaymentRefundDialog from "../Payment/PaymentRefundDialog"
import PaymentStatusChip from "../Payment/PaymentStatusChip"

export default {
  components: {
    BaseStripeTable,
    PaymentRefundDialog,
    PaymentStatusChip
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      headers: [
        {
          text: 'Amount',
          align: 'left',
          sortable: false,
        },
        {
          text: 'Status',
          sortable: false,
        },
        {
          text: 'Description',
          sortable: false,
        },
        {
          text: 'Date',
          sortable: false,
        },
        {
          text: '',
          sortable: false,
        }
      ]
    }
  },
  methods: {
    reloadTable() {
      this.$refs.paymentsTable.fetchData()
    },
    canRefund(payment) {
      const charge = get(payment, 'charges.data[0]', {})
      const status = get(payment, 'status', {})
      const amount = get(charge, 'amount', 0)
      const amountRefunded = get(charge, 'amount_refunded', 0)

      return status === 'succeeded' && amountRefunded < amount
    }
  },
}
</script>
